import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ChallengeActivityQuestionAttemptStatus } from '@examdojo/challenge';
import { IconComponent } from '@examdojo/core/icon';
import { connectState } from '@examdojo/angular/util';
import { ColorSchemeService } from '@examdojo/browser/color-scheme';

@Component({
  selector: 'dojo-challenge-activity-question-status',
  standalone: true,
  imports: [IconComponent],
  template: `
    @switch (status()) {
      @case ('TODO') {
        @if (state.darkMode) {
          <dojo-icon [icon]="'assets/images/challenge/todo-dark.svg'" [size]="18" />
        } @else {
          <dojo-icon [icon]="'assets/images/challenge/todo.svg'" [size]="18" />
        }
      }
      @case ('IN_PROGRESS') {
        <dojo-icon [icon]="'assets/images/challenge/in-progress.svg'" [size]="18" />
      }
      @case ('DONE') {
        <dojo-icon [icon]="'assets/images/challenge/done.svg'" [size]="18" />
      }
    }
  `,
  host: {
    class: 'inline-flex items-center',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChallengeActivityQuestionStatusComponent {
  constructor(private readonly userColorSchemeService: ColorSchemeService) {}
  readonly status = input.required<ChallengeActivityQuestionAttemptStatus>();

  readonly state = connectState({
    darkMode: this.userColorSchemeService.hasDarkMode$,
  });
}
